import { useTranslation } from "react-i18next";
import { Link } from "@/i18n/LocaleLink";
import site from "@/config/site";
import { FOOTER_COLUMNS } from "@/constants/navigation";
import { ROUTES } from "@/constants/routes";
import "./Footer.css";

export function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const linkLabel = (link) => {
    if (link.navId) return t(`nav.primary.${link.navId}`);
    if (link.viewAll) return t("common.footer.viewAllApps");
    return t(`nav.items.${link.fragment}.label`);
  };

  return (
    <footer className="foot">
      <div className="foot__glow" aria-hidden="true" />
      <div className="foot__inner">
        <div className="foot__top">
          <Link to={ROUTES.home} aria-label={`${site.name} home`}>
            <img src={site.logo.cream} alt={site.name} width="150" height="30" />
          </Link>
          <p className="foot__pitch">{t("common.site.shortPitch")}</p>
        </div>

        <div className="foot__cols">
          {FOOTER_COLUMNS.map((col) => (
            <nav
              key={col.titleKey}
              className="foot__col"
              aria-label={t(`common.footer.columns.${col.titleKey}`)}
            >
              <div className="foot__colTitle">{t(`common.footer.columns.${col.titleKey}`)}</div>
              {col.links.map((link) => (
                <Link key={link.navId ?? link.fragment ?? "view-all"} to={link.href} className="foot__link">
                  {linkLabel(link)}
                </Link>
              ))}
            </nav>
          ))}
        </div>

        <div className="foot__legal">
          © {year} {site.name}. {t("common.footer.legal")}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
